/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Extra_Session_Buy_WeekInputs */

const fr_extra_session_buy_week = /** @type {(inputs: Extra_Session_Buy_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acheter une séance supplémentaire (${i?.price})`)
};

/**

* @param {Extra_Session_Buy_WeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_buy_week = /** @type {((inputs: Extra_Session_Buy_WeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Buy_WeekInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_buy_week(inputs)
});